<!-- 视频 -->
<template>
    <div
        v-if="componentsData.type == 6"
        :style="`margin: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;`"
    >
        <div :style="`height: ${componentsData.content.height}px;`">
            <video controls muted playsinline preload="auto"
                class="video-div"
                :src="componentsData.content.videoList.picview"
                :style="
                    componentsData.content.version
                        ? `border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;`
                        : `border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`
                "
            ></video>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.video-div {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>